import { Icon, Text, VStack } from "@chakra-ui/react";
import unVerifiedDashboardImage from "../../../assets/svg/unverified-dashboard.svg?react";
import CustomButton from "../../../components/common/Button";

interface IUnverifiedProps {
  onOpen: VoidFunction;
  setShowOnBoarding: React.Dispatch<React.SetStateAction<boolean>>;
  setModalShownInSession: React.Dispatch<React.SetStateAction<boolean>>;
}
const Unverified: React.FC<IUnverifiedProps> = ({
  onOpen,
  setModalShownInSession,
  setShowOnBoarding,
}) => {
  const handleButtonClick = () => {
    setShowOnBoarding(true);
    setModalShownInSession(false);
    onOpen();
  };
  return (
    <>
      <VStack gap={6} width={"50%"}>
        <Icon as={unVerifiedDashboardImage} boxSize={"140px"} />
        <Text fontSize={"xl"} fontWeight={"bold"} color={"text.primary"}>
          It Looks Like You Haven’t Completed Your Profile
        </Text>
        <Text textAlign={"center"} fontSize={"md"} color={"text.secondary"}>
          Let’s fix that! Complete your profile so we can help you build your
          business and set you up for success. It only takes a few minutes, and
          once it's done, you'll be ready to showcase your products and connect
          with your customers.
        </Text>
        <CustomButton
          fontSize="md"
          fontWeight="semibold"
          type="submit"
          fontFamily={"primary"}
          px={12}
          onClick={handleButtonClick}
        >
          Complete Your Profile
        </CustomButton>
      </VStack>
    </>
  );
};
export default Unverified;
